var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDevelopment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 197.11 174.71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 101.61,
    y1: 122.83,
    x2: 95.3,
    y2: 129.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c8da2c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#80c341"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 101.96,
    y1: 122.48,
    x2: 94.95,
    y2: 129.48,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 178.84,
    y1: -11.86,
    x2: 18.18,
    y2: 148.8,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 179.2,
    y1: -12.22,
    x2: 17.83,
    y2: 149.15,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 90.74,
    y1: 50.06,
    x2: 71.61,
    y2: 69.18,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 91.09,
    y1: 49.7,
    x2: 71.26,
    y2: 69.54,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 125.49,
    y1: 50.06,
    x2: 106.37,
    y2: 69.18,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 125.85,
    y1: 49.7,
    x2: 106.01,
    y2: 69.54,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 109.88,
    y1: 48.29,
    x2: 87.22,
    y2: 70.95,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 110.24,
    y1: 47.93,
    x2: 86.87,
    y2: 71.3,
    xlinkHref: "#a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.45 130.44A4.46 4.46 0 1094 126a4.46 4.46 0 004.45 4.44zm0-6a1.53 1.53 0 11-1.53 1.56 1.53 1.53 0 011.53-1.55z",
    fill: "url(#a)",
    stroke: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.53 116.72V9.57A9.08 9.08 0 00187.46.5H9.57A9.08 9.08 0 00.5 9.57v117.8a9.08 9.08 0 009.07 9.07H74.8v34.85h-18a1.46 1.46 0 100 2.92h83.77a1.46 1.46 0 100-2.92h-18.13v-34.85h65a9.08 9.08 0 009.07-9.07v-9.73a1.77 1.77 0 00.08-.46 1.7 1.7 0 00-.06-.46zm-77 54.57h-41.8v-34.85h41.78zm74.09-43.92a6.15 6.15 0 01-6.14 6.14H9.57a6.15 6.15 0 01-6.15-6.14v-8.73H193.6zm0-11.65H3.42V9.57a6.16 6.16 0 016.15-6.15h177.89a6.16 6.16 0 016.14 6.15z",
    fill: "url(#c)",
    stroke: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.24 42.56a1.77 1.77 0 00-2.51-.12L63.36 58.31a1.77 1.77 0 000 2.62L80.73 76.8a1.77 1.77 0 001.2.46 1.75 1.75 0 001.31-.58 1.78 1.78 0 00-.11-2.51L67.19 59.62l15.94-14.55a1.78 1.78 0 00.11-2.51z",
    fill: "url(#e)",
    stroke: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.38 42.44a1.78 1.78 0 00-2.4 2.63l15.93 14.55L114 74.17a1.78 1.78 0 00-.11 2.51 1.75 1.75 0 001.31.58 1.77 1.77 0 001.2-.46l17.37-15.87a1.79 1.79 0 000-2.62z",
    fill: "url(#g)",
    stroke: "url(#h)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.3 42a1.77 1.77 0 00-2.18 1.25L92.55 75a1.79 1.79 0 001.26 2.18 1.82 1.82 0 00.46.06A1.77 1.77 0 0096 76l8.57-31.73A1.77 1.77 0 00103.3 42z",
    fill: "url(#i)",
    stroke: "url(#j)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevelopment);
export default __webpack_public_path__ + "static/media/development.e5fcad6e2a796bd54cfd80b2e0db9ba3.svg";
export { ForwardRef as ReactComponent };